import { getEntityListDynamic } from '@react/shared/helpers/getEntityList';
import { populate } from '@sly/core/constants/populate';
import MarketingPages from 'sly/marketingPages';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default MarketingPages;

export async function getServerSideProps({ params, resolvedUrl }) {
  const { api, store } = createApiClient(apiEndpoints);

  try {
    const [_, marketingPagePromise] = await Promise.allSettled(
      [
        api.getContactUsInfo.asAction(),
        api.getMarketingPage.asAction({
          'filters[slug][$eq]': params.marketingPage,
          populate: populate.marketingPage,
        }),
      ].map(store.dispatch)
    );

    await getEntityListDynamic(
      marketingPagePromise,
      'value.body.data[0].MarketingPageDz',
      api,
      store
    );

    if (
      marketingPagePromise.status === 'fulfilled' &&
      marketingPagePromise.value?.body?.data?.length == 0
    ) {
      return {
        notFound: true,
      };
    }
  } catch (e) {
    console.error(e);

    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
      params,
      path: resolvedUrl,
    },
  };
}
